<template>
  <v-navigation-drawer
    app
    class="white sidebar-filter__content"
    :width="355"
    v-model="drawer"
    style="z-index: 99"
    :permanent="$vuetify.breakpoint.lgAndUp"
    clipped
    right
    id="sidebar-filter"
    v-if="showSidebarFilter"
    :temporary="$vuetify.breakpoint.mdAndDown"
  >
    <div
      class="base-div px-4 pt-5 pb-4"
      v-if="$vuetify.breakpoint.mdAndDown"
      :class="
        me.role === 'FOUR_NETWORK'
          ? 'green100'
          : me.role === 'MARKETING'
          ? 'gray90'
          : 'purple100'
      "
    >
      <BaseButton
        type-button="tertiary"
        @click="drawer = false"
        svg-icon-name="remove"
        :is-dark-context="me.role !== 'FOUR_NETWORK' && me.role !== 'MARKETING'"
      />
    </div>
    <div v-if="!items" class="text-center py-16">
      <div class="base-div d-flex justify-center">
        <v-img src="@/assets/loading.svg" max-width="50px" />
      </div>
      <p class="caption black--text mb-0">
        {{ $t("misc.loading") }}
      </p>
    </div>
    <div
      v-if="debate && $route.name === 'roundTableItems' && debate.showDebate"
      class="pa-4"
    >
      <v-col cols="12">
        <p class="mb-3 gray90--text subtitle-1">
          {{ $t("misc.information") }}
        </p>
        <div class="mb-3 d-flex align-center">
          <SvgIcon :name="debateLocation" color="purple100" />
          <p
            class="mb-0 gray70--text body-2 pl-2"
            style="word-break: break-word"
          >
            {{ nameLocalDebate() }}
          </p>
        </div>
      </v-col>
      <v-col cols="12" class="mb-2">
        <v-divider />
      </v-col>
      <TagItem :items-tag="debate?.interests" color="tagDarkBlue" />
      <div>
        <v-row class="mt-3 pb-2 sidebar-filter__div-avatar">
          <v-avatar size="37" :class="currentUser">
            <img :src="debate?.user?.profileImage" />
          </v-avatar>
          <v-avatar
            v-if="debate?.user?.blockedType === 'BLOCKED'"
            size="14"
            class="sidebar-filter__blocked-icon"
          >
            <img src="@/assets/blocked.svg" alt="Usuário bloqueado" />
          </v-avatar>
        </v-row>
        <v-row class="mb-2">
          <p class="mb-0 subtitle-2 gray90--text">
            {{ debate?.user?.name }}
          </p>
          <p class="mb-0 body-2 gray90--text pl-1">
            {{ $t("roundTable.created") }}
          </p>
        </v-row>
        <v-row class="mb-2" align="center">
          <SvgIcon name="calendar" color="gray90" />
          <p class="mb-0 subtitle-2 gray90--text pl-2">
            {{ $t("misc.createdIn") }}
          </p>
          <p class="mb-0 subtitle-2 gray90--text pl-1">
            {{ formatDayMonthYear(debate?.createdAt) }}
          </p>
        </v-row>
        <v-row
          v-if="debate?.user?.id === me.id || me.role === 'FOUR_NETWORK'"
          align="center"
        >
          <SvgIcon name="trending_up" color="black" />
          <p class="mb-0 subtitle-2 black--text pl-2">
            {{
              debate?.totalInteractions +
              (debate?.totalInteractions === 1
                ? $t("roundTable.interaction")
                : $t("roundTable.interactions"))
            }}
          </p>
          <p class="mb-0 body-2 gray90--text pl-1">
            {{ $t("roundTable.lastDays") }}
          </p>
        </v-row>
        <v-list
          dense
          class="py-0 mt-3"
          v-if="debate?.mostEngagementUsers?.length > 0"
        >
          <v-list-item class="px-0">
            <v-row>
              <v-col cols="12" class="py-0">
                <NewSidebarItem
                  :mini="false"
                  :item="mostActiveUsers"
                  :is-fixed="true"
                  class="white black--text"
                />
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
        <v-col
          cols="12"
          v-if="debate?.mostEngagementUsers?.length > 0"
          class="mb-4"
        >
          <v-divider />
        </v-col>
        <v-row
          class="mb-2"
          v-for="(item, key) in debate?.mostEngagementUsers"
          :key="key"
        >
          <v-row class="base-div sidebar-filter__div-avatar" align="center">
            <SvgIcon
              :name="getRankingIconName(key)"
              :color="getRankingIconColor(key)"
              class="mr-3"
            />
            <v-avatar size="32" :class="currentUserRanking(item)">
              <img :src="item.profileImage" />
            </v-avatar>
            <v-avatar
              v-if="item.blockedType === 'BLOCKED'"
              size="14"
              class="sidebar-filter__blocked-icon-small"
            >
              <img src="@/assets/blocked.svg" alt="Usuário bloqueado" />
            </v-avatar>
            <div class="ml-2 sidebar-filter__user-text">
              <p class="mb-0 subtitle-2 gray90--text">
                {{ item.name }}
              </p>
              <p
                class="mb-0 caption mt-n1 gray70--text"
                v-if="!['MARKETING', 'FOUR_NETWORK'].includes(item.role)"
              >
                {{ item.companyName }}
              </p>
            </div>
          </v-row>
        </v-row>
        <v-list
          dense
          class="py-0 mx-n4"
          v-if="debate?.relatedDebates?.length > 0"
        >
          <v-list-item class="px-0">
            <v-row>
              <v-col cols="auto" class="py-0">
                <NewSidebarItem
                  :mini="false"
                  :item="relatedDebates"
                  :is-fixed="true"
                  class="white black--text"
                />
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
        <v-col cols="12" v-if="debate?.relatedDebates?.length > 0">
          <v-divider />
        </v-col>
        <v-row
          v-for="(item, key) in debate?.relatedDebates"
          :key="key"
          class="px-4 pt-4"
        >
          <p
            class="sidebar-filter__cursor sidebar-filter__break-word gray90--text"
            @click="redirectDebate(item.id)"
          >
            <span v-if="translatedDebateNames[item.id]">{{
              translatedDebateNames[item.id]
            }}</span>
            <span v-else>
              {{ item.name }}
              <span
                v-if="!translatedDebateNames[item.id]"
                style="display: none"
              >
                {{ translateDebateItem(item) }}
              </span>
            </span>
          </p>
          <v-col cols="12">
            <v-divider />
          </v-col>
        </v-row>
      </div>
    </div>
    <div
      v-if="
        community &&
        ($route.name === 'communityHome' ||
          $route.name === 'communityMembersHome')
      "
    >
      <img
        :src="community.media.mediaUrl"
        style="
          width: 100%;
          height: 76px;
          object-fit: cover;
          object-position: bottom left;
        "
      />
      <p
        class="px-4 py-1 subtitle-1 gray90--text"
        :class="
          $route.name === 'communityMembersHome' ||
          (community.owner && community.owner.id === me.id)
            ? 'mb-0'
            : ''
        "
      >
        {{ $t("misc.information") }}
      </p>
      <v-row
        class="base-div px-4 py-1"
        style="gap: 4px"
        v-if="
          ($route.name === 'communityHome' ||
            $route.name === 'communityMembersHome') &&
          community.owner &&
          community.owner.id === me.id
        "
      >
        <BaseButton
          type-button="primary"
          icon
          width="auto"
          @click="$emit('openModalUser')"
          :disabled="currentLoadingLoungeId === community.id ? disabled : false"
          svg-icon-name="add"
          v-if="me.role !== 'FOUR_NETWORK'"
        >
          {{ $t("community.newUsers") }}
        </BaseButton>
        <BaseButton
          type-button="secondary"
          @click="$router.push({ name: 'editLounge' })"
          v-if="
            (TokenService.getRule().includes('LOUNGE_UPDATE') &&
              me.role === 'FOUR_NETWORK') ||
            me.role !== 'FOUR_NETWORK'
          "
          :disabled="currentLoadingLoungeId === community.id ? disabled : false"
        >
          {{ $t("misc.edit") }}
        </BaseButton>
        <BaseButton
          type-button="remove"
          @click="$emit('delete', community.id)"
          :disabled="currentLoadingLoungeId === community.id ? disabled : false"
          v-if="me.role !== 'FOUR_NETWORK'"
        >
          {{ $t("misc.delete") }}
        </BaseButton>
      </v-row>
      <v-list dense class="py-0">
        <v-list-item class="px-0">
          <v-row>
            <v-col cols="12" class="py-0">
              <NewSidebarItem
                :mini="false"
                :item="aboutLounge"
                :is-fixed="true"
                class="white black--text"
              />
            </v-col>
          </v-row>
        </v-list-item>
      </v-list>
      <v-col cols="11" class="mx-4">
        <v-divider />
      </v-col>
      <v-row v-if="items" class="pa-4">
        <p class="caption gray90--text sidebar-filter__about-community">
          {{ community.about }}
        </p>
        <v-row class="pb-4 base-div">
          <SvgIcon name="calendar" color="gray90" />
          <p class="mb-0 gray90--text body-2 pt-1 pl-2">
            {{ $t("community.communitycreadted") }}
          </p>
          <p class="mb-0 subtitle-2 gray90--text pt-1 pl-1">
            {{ formatDayMonthYear(community.creationDate) }}
          </p>
        </v-row>
        <v-row class="base-div pb-2">
          <SvgIcon name="lock" color="gray90" />
          <p class="mb-0 subtitle-2 gray90--text pt-1 pl-2">
            {{ $t("community.private") }}
          </p>
        </v-row>
        <p class="mb-0 caption px-8 gray90--text">
          {{ $t("community.privateDescription") }}
        </p>
      </v-row>
      <div v-if="$route.name !== 'communityMembersHome'">
        <v-list dense class="py-0">
          <v-list-item class="px-0">
            <v-row>
              <v-col cols="6" class="py-0">
                <NewSidebarItem
                  :mini="false"
                  :item="loungeMembers"
                  :is-fixed="true"
                  class="white black--text"
                />
              </v-col>
              <v-col cols="6" class="text-end">
                <BaseButton
                  type-button="tertiary"
                  text
                  @click="
                    $router.push({
                      name: 'communityMembersHome',
                      params: { id: community.id },
                    })
                  "
                >
                  {{ $t("sidebar.accessAll") }}
                </BaseButton>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
        <v-col cols="11" class="mx-4">
          <v-divider />
        </v-col>
        <v-row v-if="items" class="pa-4 sidebar-filter__div-avatar">
          <v-col
            cols="2"
            v-for="(member, key) in community.lastMembers"
            :key="key"
            :class="key !== 0 ? 'ml-n2' : ''"
          >
            <v-avatar size="37" :class="currentLoungeUser(member)">
              <img :src="member.profileImage" />
            </v-avatar>
            <v-avatar
              size="14"
              class="sidebar-filter__blocked-icon-members"
              v-if="member.blockedType === 'BLOCKED'"
            >
              <img src="@/assets/blocked.svg" alt="Usuário bloqueado" />
            </v-avatar>
          </v-col>
          <v-row
            class="base-div py-2 mb-2"
            v-if="community?.lastMembers?.length > 0"
          >
            <p class="mb-0 subtitle-2 gray90--text">
              {{
                community.lastMembers.length === 1
                  ? community.lastMembers[0].name
                  : community.lastMembers[0].name +
                    ", " +
                    community.lastMembers[1].name
              }}
            </p>
            <p
              class="mb-0 gray70--text body-2 pl-1"
              v-if="
                community?.lastMembers?.length >= 2 &&
                community?.totalMembers - 2 > 0
              "
            >
              {{ $t("timeline.other") }}
              {{ community?.totalMembers - 2 }}
            </p>
          </v-row>
          <v-row>
            <v-col cols="auto" class="sidebar-filter__div-avatar">
              <v-avatar size="37" :class="currentLoungeUser(community.owner)">
                <img :src="community.owner.profileImage" />
              </v-avatar>
              <v-avatar
                v-if="community.owner.blockedType === 'BLOCKED'"
                size="14"
                class="sidebar-filter__blocked-icon"
              >
                <img src="@/assets/blocked.svg" alt="Usuário bloqueado" />
              </v-avatar>
            </v-col>
            <v-col cols="10" class="pl-3">
              <v-row>
                <p class="mb-0 subtitle-2 gray90--text">
                  {{ community.owner.name }}
                </p>
                <p class="mb-0 body-2 gray90--text pl-1">
                  {{ $t("community.owner") }}
                </p>
              </v-row>
            </v-col>
          </v-row>
        </v-row>
      </div>
    </div>
    <div
      v-if="
        items &&
        $route.name !== 'roundTableItems' &&
        $route.name !== 'communityMembersHome' &&
        showFilter
      "
    >
      <v-list dense class="py-0 mt-2" v-if="items.lounges.length > 0">
        <v-list-item class="px-0">
          <v-row>
            <v-col cols="10" class="py-0">
              <NewSidebarItem
                :mini="false"
                :item="filterLoungeHeader"
                :is-fixed="true"
                class="white black--text"
                :is-filter="true"
                @filter="clearFilter('lounge')"
              />
            </v-col>
            <v-col
              cols="2"
              v-if="selectedLounges.length !== 0"
              class="pt-4 sidebar-filter__cursor"
              @click="clearFilter('lounge')"
            >
              <SvgIcon name="filters_clear" color="black" />
            </v-col>
          </v-row>
        </v-list-item>
      </v-list>
      <v-col cols="11" class="mx-4" v-if="items.lounges.length > 0">
        <v-divider />
      </v-col>
      <v-row
        v-if="
          items &&
          (allLounges || items.lounges.length <= 4) &&
          items.lounges.length > 0
        "
        class="pa-4"
      >
        <v-col
          cols="auto"
          class="pr-2 pb-2"
          v-for="(item, index) in items.lounges"
          :key="index"
        >
          <BaseButton
            type-button="filter"
            :selected="isFilterSelected(item, 'lounge')"
            @click="selectItem(item, 'lounge')"
            v-html="item.name"
          />
        </v-col>
      </v-row>
      <v-row
        v-if="items && !allLounges && items.lounges.length > 4"
        class="pa-4"
      >
        <v-col
          cols="auto"
          class="pr-2 pb-2"
          v-for="(item, index) in loungesFilter[0]"
          :key="index"
        >
          <BaseButton
            type-button="filter"
            :selected="isFilterSelected(item, 'lounge')"
            @click="selectItem(item, 'lounge')"
            v-html="item.name"
          />
        </v-col>
      </v-row>
      <v-row
        class="base-div d-flex justify-center sidebar-filter__cursor"
        v-if="items.lounges.length > 4"
        @click="allLounges = !allLounges"
      >
        <v-col cols="4">
          <v-divider />
        </v-col>
        <v-col cols="2" class="text-center sidebar-filter__see-more">
          <p class="subtitle-2 purple100--text mb-0">
            {{ $t("sidebar.seeMore") + (allLounges ? "-" : "+") }}
          </p>
        </v-col>
        <v-col cols="4">
          <v-divider />
        </v-col>
      </v-row>
      <v-list dense class="py-0 mt-2" v-if="items.events.length > 0">
        <v-list-item class="px-0">
          <v-row>
            <v-col cols="10" class="py-0">
              <NewSidebarItem
                :mini="false"
                :item="filterEventHeader"
                :is-fixed="true"
                class="white black--text"
              />
            </v-col>
            <v-col
              cols="2"
              v-if="selectedEvents.length !== 0"
              class="pt-4 sidebar-filter__cursor"
              @click="clearFilter('event')"
            >
              <SvgIcon name="filters_clear" color="black" />
            </v-col>
          </v-row>
        </v-list-item>
      </v-list>
      <v-col cols="11" class="mx-4" v-if="items.events.length > 0">
        <v-divider />
      </v-col>
      <v-row
        v-if="
          items &&
          (allEvents || items.events.length <= 4) &&
          items.events.length > 0
        "
        class="pa-4"
      >
        <v-col
          cols="auto"
          class="pr-2 pb-2"
          v-for="(item, index) in items.events"
          :key="index"
        >
          <BaseButton
            type-button="filter"
            :selected="isFilterSelected(item, 'event')"
            @click="selectItem(item, 'event')"
            v-html="item.name"
          />
        </v-col>
      </v-row>
      <v-row v-if="items && !allEvents && items.events.length > 4" class="pa-4">
        <v-col
          cols="auto"
          class="pr-2 pb-2"
          v-for="(item, index) in eventsFilter[0]"
          :key="index"
        >
          <BaseButton
            type-button="filter"
            :selected="isFilterSelected(item, 'event')"
            @click="selectItem(item, 'event')"
            v-html="item.name"
          />
        </v-col>
      </v-row>
      <v-row
        class="base-div d-flex justify-center sidebar-filter__cursor"
        v-if="items.events.length > 4"
        @click="allEvents = !allEvents"
      >
        <v-col cols="4">
          <v-divider />
        </v-col>
        <v-col cols="2" class="text-center sidebar-filter__see-more">
          <p class="subtitle-2 purple100--text mb-0">
            {{ allEvents ? "Ver -" : "Ver +" }}
          </p>
        </v-col>
        <v-col cols="4">
          <v-divider />
        </v-col>
      </v-row>
      <v-list
        dense
        class="py-0 mt-2"
        v-if="items?.debates?.length > 0 && $route.name === 'timelineHome'"
      >
        <v-list-item class="px-0">
          <v-row>
            <v-col cols="auto" class="py-0">
              <NewSidebarItem
                :mini="false"
                :item="debateHeader"
                :is-fixed="true"
                class="white black--text"
              />
            </v-col>
            <v-spacer />
            <BaseButton
              type-button="tertiary"
              text
              @click="$router.push({ name: 'roundTableList' })"
              v-html="$t('sidebar.accessAll')"
            />
          </v-row>
        </v-list-item>
      </v-list>
      <v-col
        cols="11"
        class="mx-4"
        v-if="items?.debates?.length > 0 && $route.name === 'timelineHome'"
      >
        <v-divider />
      </v-col>
      <v-row
        v-if="items?.debates?.length > 0 && $route.name === 'timelineHome'"
        class="px-4 pb-4"
      >
        <v-col cols="12" v-for="(item, index) in items.debates" :key="index">
          <p
            class="sidebar-filter__cursor sidebar-filter__break-word gray90--text pt-4"
            @click="redirectDebate(item.id)"
          >
            {{ item.name }}
          </p>
          <v-col cols="11">
            <v-divider />
          </v-col>
        </v-col>
      </v-row>
      <v-list
        dense
        class="py-0"
        v-if="items?.interests.length > 0 && $route.name === 'timelineHome'"
      >
        <v-list-item class="px-0">
          <v-row>
            <v-col cols="12" class="py-0">
              <NewSidebarItem
                :mini="false"
                :item="highlightsHeader"
                :is-fixed="true"
                class="white black--text"
              />
            </v-col>
          </v-row>
        </v-list-item>
      </v-list>
      <v-col
        cols="11"
        class="mx-4"
        v-if="items?.interests.length > 0 && $route.name === 'timelineHome'"
      >
        <v-divider />
      </v-col>

      <v-row
        v-if="items?.interests.length > 0 && $route.name === 'timelineHome'"
        class="pa-4"
      >
        <v-col cols="12">
          <TagItem
            :items-tag="items?.interests"
            color="tagDarkBlue"
            :is-click="true"
            class="sidebar-filter__cursor"
          />
        </v-col>
        <v-col
          cols="11"
          class="pt-2"
          v-if="
            items?.suggestedCompanies &&
            me.role === 'PARTICIPANT' &&
            $route.name === 'timelineHome'
          "
        >
          <v-divider />
        </v-col>
      </v-row>
      <v-list
        dense
        class="py-0"
        v-if="
          items?.suggestedCompanies &&
          me.role === 'PARTICIPANT' &&
          $route.name === 'timelineHome'
        "
      >
        <v-list-item class="px-0">
          <v-row>
            <v-col cols="10" class="py-0">
              <NewSidebarItem
                :mini="false"
                :item="suggestedCompanies"
                :is-fixed="true"
                class="white black--text"
              />
            </v-col>
          </v-row>
        </v-list-item>
      </v-list>
      <v-col
        cols="11"
        class="mx-4"
        v-if="
          items?.suggestedCompanies &&
          me.role === 'PARTICIPANT' &&
          $route.name === 'timelineHome'
        "
      >
        <v-divider />
      </v-col>
      <v-row
        v-if="
          items?.suggestedCompanies &&
          me.role === 'PARTICIPANT' &&
          $route.name === 'timelineHome'
        "
        class="base-div pa-4"
      >
        <v-col
          cols="12"
          v-for="(item, index) in items?.suggestedCompanies"
          :key="index"
          class="mb-2 sidebar-filter__div-avatar"
        >
          <div
            class="sidebar-filter__suggestion-item"
            tabindex="0"
            @click="redirectProfileCompany(item.id)"
            @keyup.enter="redirectProfileCompany(item.id)"
          >
            <v-avatar size="46" class="sidebar-filter__avatar">
              <img :src="item.profileImage" />
            </v-avatar>
            <div class="ml-2 d-flex align-center">
              <p class="mb-0 subtitle-1 gray90--text">
                {{ item.name }}
              </p>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-navigation-drawer>
</template>
<script lang="ts">
import i18n from "@/plugins/i18n";
import Component, { mixins } from "vue-class-component";
import { ActionMixin } from "../mixins/ActionMixin";
import { Action, State } from "vuex-class";
import { FilterSidebarItem, SidebarRightItem } from "../types";
import { Prop, Watch } from "vue-property-decorator";
import { formatDayMonthYear } from "@/utils/format";
import TagItem from "@/components/TagItem.vue";
import { Event } from "@/types";
import translate from "translate";
import { TokenService } from "@/api/storage";
@Component({
  components: {
    TagItem,
  },
})
export default class SidebarFilter extends mixins(ActionMixin) {
  @Prop(Object) debate: any;
  @Prop(Object) community: any;
  @Prop(Number) currentLoadingLoungeId: number;
  @Prop(Boolean) disabled: boolean;
  @Prop({ default: false }) toggle: boolean;
  @Prop({ default: true }) showFilter: boolean;
  @Prop({ default: false }) loadingFilter: boolean;
  TokenService = TokenService;
  filterLoungeHeader = {
    svgIcon: "exclusive_lounge",
    name: i18n.t("sidebar.filterLounge"),
    route: "",
  };
  filterEventHeader = {
    svgIcon: "events",
    name: i18n.t("sidebar.filterEvent"),
    route: "",
  };
  debateHeader = {
    svgIcon: "chat",
    name: i18n.t("sidebar.debate"),
    route: "",
  };
  highlightsHeader = {
    svgIcon: "trending_up",
    name: i18n.t("sidebar.highlights"),
    route: "",
  };
  mostActiveUsers = {
    svgIcon: "group_users",
    name: i18n.t("sidebar.mostActiveUsers"),
    route: "",
  };
  relatedDebates = {
    svgIcon: "chat",
    name: i18n.t("sidebar.relatedDebates"),
    route: "",
  };
  aboutLounge = {
    svgIcon: "exclusive_lounge",
    name: i18n.t("community.about"),
    route: "",
  };
  loungeMembers = {
    svgIcon: "group_users",
    name: i18n.t("community.members"),
    route: "",
  };
  suggestedCompanies = {
    svgIcon: "work",
    name: i18n.t("sidebar.suggestedCompanies"),
    route: "",
  };
  drawer = true;
  items: SidebarRightItem | null = null;
  selectedLounges: FilterSidebarItem[] = [];
  selectedEvents: FilterSidebarItem[] = [];
  formatDayMonthYear = formatDayMonthYear;
  loungesFilter: any = [];
  allLounges = false;
  eventsFilter: any = [];
  allEvents = false;
  translatedDebateNames: { [key: number]: string } = {};
  @State((state) => state.profile.me) me: any;
  @State("selectedEvent") selectedEvent: any;
  @State("selectedLounge") selectedLounge: any;
  @Action("timeline/requestSidebarItems") requestSidebarItems: any;
  @Action("updateSelectedLounge") updateSelectedLounge: any;
  @Action("updateSelectedEvent") updateSelectedEvent: any;
  @Action("roundTable/changeUpdateDebate") changeUpdateDebate: any;
  get currentUser(): string {
    return this.debate?.user?.role === "PARTICIPANT"
      ? "avatar-green"
      : this.debate?.user?.role === "EXECUTIVE"
      ? "avatar-red"
      : this.debate?.user?.role === "EQUIPE"
      ? "avatar-black"
      : this.debate?.user?.role === "PARTNER"
      ? "avatar-blue"
      : "company-profile-border";
  }
  get debateLocation(): string {
    return this.debate?.bindedBy === "COMMUNITY"
      ? "exclusive_lounge"
      : this.debate?.bindedBy === "EVENT"
      ? "events"
      : "privacy_public";
  }
  get showSidebarFilter(): boolean {
    const shouldShow =
      this.$route.name === "timelineHome" && this.me.role === "MARKETING"
        ? Boolean(
            this.items &&
              (this.items?.interests?.length > 0 ||
                this.items?.debates?.length > 0 ||
                this.items?.lounges?.length > 0 ||
                this.items?.events?.length > 0)
          )
        : true;
    this.$nextTick(() => {
      this.$emit("sidebar-filter-visibility", shouldShow);
    });
    return shouldShow;
  }
  created(): void {
    this.fetchData();
  }
  fetchData(): void {
    this.withLoading(async () => {
      await this.requestSidebarItems().then(async (data: SidebarRightItem) => {
        // Primeiro traduzir todos os debates antes de atribuir ao this.items
        const translatedDebates = [...data.debates];

        // Usar Promise.all para executar todas as traduções em paralelo
        await Promise.all(
          translatedDebates.map(async (item: any) => {
            if (
              item.translation?.translatedName?.originalLanguage !==
              this.$root.$i18n.locale
            ) {
              item.name = item.translation?.translatedName?.contentLanguage
                ? item.translation?.translatedName?.translatedValue
                : await translate(item.name, {
                    to: this.$root.$i18n.locale,
                    from: item.translation?.translatedName?.originalLanguage,
                  });
            }
          })
        );

        // Criar um novo objeto para garantir a reatividade
        this.items = {
          ...data,
          debates: translatedDebates,
        };

        this.loungesFilter.push(data.lounges.slice(0, 4));
        this.eventsFilter.push(data.events.slice(0, 4));
        this.selectedEvents = this.selectedEvent;
        this.selectedLounges = this.selectedLounge;
        this.updateSelectedLounge(this.selectedLounges);
        this.updateSelectedEvent(this.selectedEvents);
      });
    });
  }
  selectItem(item: FilterSidebarItem, type: string): void {
    if (this.loadingFilter) return;
    if (type === "event") {
      if (
        !this.selectedEvents.find(
          (element: FilterSidebarItem) => element.id === item.id
        )
      ) {
        this.selectedEvents.push(item);
      } else {
        this.selectedEvents = this.selectedEvents.filter(
          (element: FilterSidebarItem) => element.id !== item.id
        );
      }
      this.updateSelectedEvent(this.selectedEvents);
    } else {
      if (
        !this.selectedLounges.find(
          (element: FilterSidebarItem) => element.id === item.id
        )
      ) {
        this.selectedLounges.push(item);
      } else {
        this.selectedLounges = this.selectedLounges.filter(
          (element: FilterSidebarItem) => element.id !== item.id
        );
      }
      this.updateSelectedLounge(this.selectedLounges);
    }
  }
  classButton(item: FilterSidebarItem, type: string): string {
    if (type === "event") {
      return this.selectedEvents.find(
        (element: FilterSidebarItem) => element.id === item.id
      )
        ? "purple40 subtitle-1"
        : "sidebar-filter__border-selected";
    } else {
      return this.selectedLounges.find(
        (element: FilterSidebarItem) => element.id === item.id
      )
        ? "purple40 subtitle-1"
        : "sidebar-filter__border-selected";
    }
  }
  isFilterSelected(item: FilterSidebarItem, type: string): boolean {
    if (type === "event") {
      return !!this.selectedEvents.find(
        (element: FilterSidebarItem) => element.id === item.id
      );
    }
    return !!this.selectedLounges.find(
      (element: FilterSidebarItem) => element.id === item.id
    );
  }
  redirectSearchTag(id: number): void {
    this.$router.push({ name: "searchTagId", params: { id: `${id}` } });
  }
  redirectProfileCompany(id: number): void {
    this.$router.push({ name: "profileMarketing", params: { id: `${id}` } });
  }
  clearFilter(type: string): void {
    if (this.loadingFilter) return;
    if (type === "lounge") {
      this.selectedLounges = [];
      this.updateSelectedLounge(this.selectedLounges);
    } else {
      this.selectedEvents = [];
      this.updateSelectedEvent(this.selectedEvents);
    }
  }
  currentLoungeUser(user: any): string {
    return user.role === "PARTICIPANT"
      ? "avatar-green"
      : user.role === "EXECUTIVE"
      ? "avatar-red"
      : user.role === "EQUIPE"
      ? "avatar-black"
      : user.role === "PARTNER"
      ? "avatar-blue"
      : "company-profile-border";
  }
  getRankingIconName(pos: number): string {
    return pos === 0 ? "1st_place" : pos === 1 ? "2nd_place" : "3rd_place";
  }
  getRankingIconColor(pos: number): string {
    return pos === 0
      ? "orangeNotification"
      : pos === 1
      ? "gray70"
      : "brownRanking";
  }
  currentUserRanking(item: any): string {
    return item.role === "PARTICIPANT"
      ? "avatar-green"
      : item.role === "EXECUTIVE"
      ? "avatar-red"
      : item.role === "EQUIPE"
      ? "avatar-black"
      : item.role === "PARTNER"
      ? "avatar-blue"
      : "company-profile-border-mini";
  }
  redirectDebate(id: number): void {
    if (this.$route.name === "roundTableItems") {
      this.$router.replace({
        name: "roundTableItems",
        params: { id: String(id) },
      });
      this.changeUpdateDebate(true);
    } else {
      this.$router.push({
        name: "roundTableItems",
        params: { id: String(id) },
      });
    }
  }
  nameLocalDebate(): string {
    return this.debate?.bindedBy === "COMMUNITY"
      ? this.debate?.communities?.reduce(
          (string: string, lounge: Event, index: number) => {
            if (index === this.debate?.communities?.length - 1)
              string += String(lounge.name);
            else if (lounge.name) string += lounge.name + ",";
            return string;
          },
          ""
        )
      : this.debate?.bindedBy === "EVENT"
      ? this.debate?.events?.reduce(
          (string: string, event: Event, index: number) => {
            if (index === this.debate?.events?.length - 1)
              string += String(event.name);
            else if (event.name) string += event.name + ",";
            return string;
          },
          ""
        )
      : `${i18n.t("misc.public")}`;
  }
  async nameDebate(item: any): Promise<string> {
    // Se já temos a tradução no cache, retornamos imediatamente
    if (this.translatedDebateNames[item.id]) {
      return this.translatedDebateNames[item.id];
    }

    // Se o idioma do debate é diferente do idioma atual, traduzimos
    if (
      item.translation?.translatedName?.originalLanguage !==
      this.$root.$i18n.locale
    ) {
      try {
        const translatedName = item.translation?.translatedName?.contentLanguage
          ? item.translation?.translatedName?.translatedValue
          : await translate(item.name, {
              to: this.$root.$i18n.locale,
              from: item.translation?.translatedName?.originalLanguage,
            });

        // Usar $set para garantir reatividade ao adicionar nova propriedade
        this.$set(this.translatedDebateNames, item.id, translatedName);
        return translatedName;
      } catch (error) {
        console.error("Erro ao traduzir:", error);
        // Em caso de erro, usamos o nome original
        this.$set(this.translatedDebateNames, item.id, item.name);
        return item.name;
      }
    } else {
      // Se o idioma já é o mesmo, apenas armazenamos no cache
      this.$set(this.translatedDebateNames, item.id, item.name);
      return item.name;
    }
  }

  async translateDebateItem(item: any): Promise<void> {
    // Este método é chamado no template para iniciar a tradução de forma reativa
    if (!item || !item.id || this.translatedDebateNames[item.id]) return;
    // Inicia a tradução e armazena no cache
    await this.nameDebate(item);
    // Força a atualização da interface
    this.$forceUpdate();
  }
  @Watch("toggle", { immediate: true }) onItemChanged(): void {
    if (this.$vuetify.breakpoint.mdAndDown) this.drawer = this.toggle;
  }

  @Watch("$vuetify.breakpoint.lgAndUp") onBreakpointChanged(
    newVal: boolean
  ): void {
    // Fechar drawer para evitar overlay quando redimensiona de lg para md/menor
    if (!newVal) {
      this.drawer = false;
    }
  }

  @Watch("debate", { immediate: true, deep: true })
  onDebateChanged(newValue: any): void {
    if (
      newValue &&
      newValue.relatedDebates &&
      newValue.relatedDebates.length > 0
    ) {
      // Inicializa as traduções para todos os debates relacionados
      this.$nextTick(() => {
        newValue.relatedDebates.forEach((item: any) => {
          this.translateDebateItem(item);
        });
      });
    }
  }
}
</script>
<style lang="sass">
.sidebar-filter__
  &border-selected
    border: 1px solid var(--v-purple70-base) !important
    background: var(--v-white-base) !important
    font-weight: 700 !important
  &interest-item
    cursor: pointer
    background: var(--v-gray35-base) !important
    border-radius: 5px !important
  &debate
    min-width: auto !important
  &content
    .v-navigation-drawer__content
      @media (min-width: 1264px)
        overflow: hidden !important
  &interest-item
    background: var(--v-gray35-base) !important
    border-radius: 16px !important
  &btn
    border: 1px solid var(--v-purple100-base)
    width: 100% !important
  &border-gray
    border: 1px solid var(--v-gray70-base)
  &btn-delete
    background: #FFE0E1
  &btn-delete-text
    color: var(--v-redLightSurvey-base)
  &cursor
    cursor: pointer
  &see-more
    margin-top: -10px
  &about-community
    overflow: auto
    max-height: 80px
    word-break: break-word
  &break-word
    word-break: break-word
    font-weight: 600 !important
    font-size: 12px !important
  &avatar
    border-radius: 16px !important
  &suggestion-item
    display: flex
    align-items: center
    border-radius: 16px
    background: var(--v-white-base)
    cursor: pointer
    width: 100%
    padding: 4px 8px 4px 4px
    outline: none
    border: 1px solid transparent
    transition: box-shadow 0.2s ease, border-color 0.2s ease
    &:hover p,
    &:active p,
    &:focus-visible p
      color: var(--v-purple100-base) !important
    &:active
      box-shadow: 0 2px 2px 0 #BBB inset
    &:focus-visible
      border-color: var(--v-tealFocus-base)
  &div-avatar
    position: relative
  &blocked-icon
    position: absolute
    margin-top: 23px
    margin-left: -10px
  &blocked-icon-small
    position: absolute
    margin-top: 18px
    margin-left: 57px
  &blocked-icon-company
    position: absolute
    margin-top: 32px
    margin-left: 34px
  &blocked-icon-members
    position: absolute
    margin-top: 23px
    z-index: 2
    margin-left: -11px
  &user-text
    flex: 1 1 0
    min-width: 0
    overflow: hidden
    > p
      min-width: 0
      max-width: 100%
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
.avatar-green
  border: 2px solid var(--v-greenCLevel-base) !important
  border-radius: 22px !important
.avatar-red
  border: 2px solid var(--v-redExecutive-base) !important
  border-radius: 22px !important
.avatar-black
  border: 2px solid var(--v-black-base) !important
  border-radius: 22px !important
.avatar-blue
  border: 2px solid var(--v-bluePartner-base) !important
  border-radius: 22px !important
</style>
